import { cn } from "@shared/ui";
import PopGradient from "./PopGradient";

const LINE_WIDTHS = ["w-3/4", "w-1/2", "w-2/3"];

const EmptySearchMark = ({ className }: { className?: string }) => (
  <span
    aria-hidden
    className={cn(
      "relative flex h-24 w-28 items-center justify-center",
      className
    )}
  >
    <span className="flex h-24 w-20 flex-col gap-2.5 rounded-lg border border-live-end/30 bg-gradient-to-br from-live-start/10 to-live-end/10 px-3 pt-4 motion-safe:animate-success-pop">
      {LINE_WIDTHS.map((width, i) => (
        <span
          key={width}
          style={{ animationDelay: `${120 + i * 90}ms` }}
          className={cn(
            "h-1.5 origin-left rounded-full motion-safe:animate-empty-line",
            i === 0
              ? "bg-gradient-to-r from-live-start/60 to-live-end/60"
              : "bg-border-subtle",
            width
          )}
        />
      ))}
    </span>
    <span className="absolute bottom-0 right-0 flex size-11 items-center justify-center rounded-full bg-ink text-on-primary ring-4 ring-surface motion-safe:animate-search-sweep">
      <svg viewBox="0 0 24 24" fill="none" className="size-5">
        <PopGradient id="search-gradient" x1={4.5} y1={4.5} x2={19.5} y2={19.5} />
        <circle
          cx="10.5"
          cy="10.5"
          r="6"
          stroke="url(#search-gradient)"
          strokeWidth={2.25}
        />
        <path
          d="M15 15l4.5 4.5"
          stroke="url(#search-gradient)"
          strokeWidth={2.25}
          strokeLinecap="round"
        />
      </svg>
    </span>
  </span>
);

export default EmptySearchMark;
